import { render, staticRenderFns } from "./UltimosRecibos.vue?vue&type=template&id=50fe8944"
import script from "./UltimosRecibos.vue?vue&type=script&lang=ts"
export * from "./UltimosRecibos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports